import React from 'react'
import dayjs from 'utils/dayjs'

import { ETaskStatus, TSubTask } from 'types/GlobalTask'

import { useTranslation } from 'language/translator'

import SelectDate from 'components_new/molecules/SelectDate'

interface DeadlineFieldProps {
  onChange: (value: string | null) => void
  status: TSubTask['status']
  value: TSubTask['deadline_date']
}

function isOverdue(
  value: TSubTask['deadline_date'],
  status: TSubTask['status']
) {
  return (
    value !== null &&
    status !== ETaskStatus.DONE &&
    dayjs(value).isBefore(dayjs(), 'day')
  )
}

const DeadlineField = (props: DeadlineFieldProps) => {
  const { onChange, status, value } = props

  const { t } = useTranslation()

  return (
    <SelectDate
      closeOnSelect={true}
      DateCalendarProps={{ onChange }}
      TextFieldProps={{
        error: isOverdue(value, status),
        placeholder: t('tasks', 'no_deadline')
      }}
      value={value}
      variant="text"
    />
  )
}

export default DeadlineField
